import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router, Event as NavigationEvent } from '@angular/router';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { SelectionInfo } from '../../selectors/multi-selection/multi-selection.model';
import { EquipmentDistancingComponent } from './equipment-distancing/equipment-distancing.component';
import { ExerciserCleaningComponent } from './exerciser-cleaning/exerciser-cleaning.component';
import { StaffCleaningComponent } from './staff-cleaning/staff-cleaning.component';


@Component({
  selector: 'app-health-and-safety',
  templateUrl: './health-and-safety.component.html',
  styleUrls: ['./health-and-safety.component.scss']
})
export class HealthAndSafetyComponent implements AfterViewInit {
  private selectionInfo: SelectionInfo;
  private active: number;
  private activatedComponentRef: any

  @ViewChild('healthSafetyBase', { static: false }) healthSafeEle: ElementRef;

  breadCrumbData = [
    { pageName: 'DASHBOARD', path: '/dashboard' },
    { pageName: 'MENU.EQUIPSETTING' },
    { pageName: 'HEALTH.SAFETY' },
    { pageName: 'EQUIP.DISTANCING' }
  ];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private commonUtil: CommonUtil
  ) { }

  ngAfterViewInit(): void {
    this.active = 1;
    this.setTabData('equipmentDistancing');
  }

  navigateToChild(childPath: string) {
    this._router.navigate([childPath], { relativeTo: this._route });
    this.setTabData(childPath);
  }

  setTabData(currentPath: string): void {
    if (currentPath === 'equipmentDistancing') {
      this.active = 1;
      this.breadCrumbData[3].pageName = 'EQUIP.DISTANCING';
    } else if (currentPath === 'exerciserCleaning') {
      this.active = 2;
      this.breadCrumbData[3].pageName = 'EXER.CLEANING';
    } else if (currentPath === 'staffCleaning') {
      this.active = 3;
    }
  }

  private onSelectionChange(selectionInfo: SelectionInfo) {
    setTimeout(() => {
      this.selectionInfo = selectionInfo;
      if(selectionInfo.facility.summary?.facilityRights.healthSafety != 'true') {
        this.commonUtil.redirectToAvailablePage();
      } else if(this.activatedComponentRef) {
        this.activatedComponentRef.onSelectionChange(this.selectionInfo);
      }
    });
  }

  private onTabActivated(componentRef: any) {
    if(componentRef instanceof StaffCleaningComponent ||
      componentRef instanceof ExerciserCleaningComponent || 
      componentRef instanceof EquipmentDistancingComponent) {
      this.activatedComponentRef = componentRef;
      componentRef.onSelectionChange(this.selectionInfo);
    }
  }
}
